// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".status_note[data-v-d72a0788]{font-size:.75rem;line-height:1.3}", "",{"version":3,"sources":["webpack://./resources/client/forms/FollowUpTemplateForm.vue"],"names":[],"mappings":"AAEA,8BACE,gBAAA,CACA,eADF","sourcesContent":["\n\n.status_note {\n  font-size: 0.75rem;\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
